/**
 * Main Router Configuration
 *
 * Assembles all feature routes into a single router.
 */

import { registerRouter } from '@bb/session-manager';
import { createRouter } from '@tanstack/react-router';
import NotFound from '../pages/NotFound/NotFound';
import { adminRoutes } from './features/adminRoutes';
import { clauseRoutes } from './features/clauseRoutes';
import { contractRoutes } from './features/contractRoutes';
import { homeRoutes } from './features/homeRoutes';
import { modelRoutes } from './features/modelRoutes';
import { reportingRoutes } from './features/reportingRoutes';
import { subscriptionRoutes } from './features/subscriptionRoutes';
import { publicRoutes } from './publicRoutes';
import { authLayoutRoute, rootRoute } from './rootRoute';

// ============================================
// BUILD ROUTE TREE
// ============================================
const routeTree = rootRoute.addChildren([
  // Public routes (login, logout)
  ...publicRoutes,
  // Authenticated routes under /bbweb
  authLayoutRoute.addChildren([
    ...homeRoutes,
    ...contractRoutes,
    ...clauseRoutes,
    ...modelRoutes,
    ...adminRoutes,
    ...reportingRoutes,
    ...subscriptionRoutes,
  ]),
]);

// ============================================
// CREATE ROUTER
// ============================================
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  // Styled 404 (with a "return home" link) for any unmatched path. Rendered inside the
  // deepest matched route's outlet, so /bbweb/* 404s keep the app bar.
  defaultNotFoundComponent: () => <NotFound />,
});

// Register for auth state invalidation
registerRouter(router);

// Note: TypeScript type registration is not needed for JSX projects
// but would be: declare module '@tanstack/react-router' { interface Register { router: typeof router } }
